import React, { useState, useEffect } from 'react'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { db } from '../../firebase/firebase'
import { t } from '../../components/i18n/i18n'
import "../../assets/css/common.css"
import back from "../../assets/images/elements/aboutHeader.jpg"

const formatDate = (ts) => {
  if (!ts) return ''
  return new Date(ts.seconds * 1000).toLocaleDateString('uk-UA', {
    day: 'numeric', month: 'long', year: 'numeric',
  })
}

export const NewsFeed = () => {
  const [news, setNews] = useState([])
  const [loading, setLoading] = useState(true)
  const [expanded, setExpanded] = useState(null)

  useEffect(() => {
    const q = query(collection(db, 'news'), orderBy('createdAt', 'desc'))
    const unsub = onSnapshot(q, snap => {
      setNews(snap.docs.map(d => ({ id: d.id, ...d.data() })))
      setLoading(false)
    }, () => setLoading(false))
    return unsub
  }, [])

  return (
    <section className='text_container_light'>
      <div className='container_100'>

        {/* Header banner */}
        <div className='backImg15'>
          <img src={back} alt='' />
          <div className='text_container_dark_15'>
            <div className='h1_15'>{t('newsfeedTitle')}</div>
          </div>
        </div>

        <div className='container boxItems' style={{ marginTop: '30px' }}>

          {loading && (
            <p style={{ color: '#999', textAlign: 'center', padding: '40px 0' }}>•••</p>
          )}

          {!loading && news.length === 0 && (
            <p style={{ color: '#999', textAlign: 'center', padding: '40px 0' }}>
              {t('newsfeedEmpty')}
            </p>
          )}

          <div style={s.grid}>
            {news.map(item => {
              const isOpen = expanded === item.id
              return (
                <article key={item.id} style={s.card}>
                  {item.photoUrl && (
                    <div style={s.imgWrap}>
                      <img src={item.photoUrl} alt={item.title} style={s.img} />
                    </div>
                  )}
                  <div style={s.body}>
                    <div style={s.date}>{formatDate(item.createdAt)}</div>
                    <h2 style={s.title}>{item.title}</h2>

                    {item.content && (
                      <div style={s.content}>
                        {isOpen
                          ? <p style={s.text}>{item.content}</p>
                          : <p style={s.text}>{item.content.slice(0, 200)}{item.content.length > 200 ? '…' : ''}</p>
                        }
                        {item.content.length > 200 && (
                          <button
                            style={s.readMore}
                            onClick={() => setExpanded(isOpen ? null : item.id)}
                          >
                            {isOpen ? t('newsfeedCollapse') : t('newsfeedReadMore')}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </article>
              )
            })}
          </div>

        </div>
      </div>
    </section>
  )
}

const s = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '28px',
    marginTop: '8px',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    border: '1px solid #f0e4d4',
    display: 'flex',
    flexDirection: 'column',
  },
  imgWrap: {
    width: '100%',
    height: '200px',
    overflow: 'hidden',
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  body: {
    padding: '20px 22px 22px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  date: {
    fontSize: '12px',
    color: '#b8a090',
    marginBottom: '8px',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#2d1f14',
    margin: '0 0 12px',
    lineHeight: '1.35',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
  },
  content: {
    flex: 1,
  },
  text: {
    fontSize: '14px',
    color: '#5a5a5a',
    lineHeight: '1.7',
    margin: '0 0 12px',
    whiteSpace: 'pre-wrap',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
  },
  readMore: {
    background: 'none',
    border: 'none',
    color: '#8b6044',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    padding: 0,
    textDecoration: 'underline',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
  },
}
